export default "__VITE_ASSET__DLHhZVdl__"